import { render } from "./EduRegisterConfirmPage.vue?vue&type=template&id=0a935c9c&scoped=true"
import script from "./EduRegisterConfirmPage.vue?vue&type=script&lang=js"
export * from "./EduRegisterConfirmPage.vue?vue&type=script&lang=js"

import "./EduRegisterConfirmPage.vue?vue&type=style&index=0&id=0a935c9c&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a935c9c"]])

export default __exports__